import { render, staticRenderFns } from "./popupBuscarPersona.vue?vue&type=template&id=a7fdf90a&scoped=true&"
import script from "./popupBuscarPersona.vue?vue&type=script&lang=js&"
export * from "./popupBuscarPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fdf90a",
  null
  
)

export default component.exports